import { render, staticRenderFns } from "./CustomFormulaConfiguration.vue?vue&type=template&id=2447295b&"
import script from "./CustomFormulaConfiguration.vue?vue&type=script&lang=ts&"
export * from "./CustomFormulaConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports